import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'app-publish-component',
  imports: [
    TranslatePipe
],
  templateUrl: './publish-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './publish-component.scss'
})

export class PublishComponent implements OnInit {


  ngOnInit(): void {
  }
}
